// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__Ycb0E","ranges":"BmiRanges_ranges__2FyQk"};